<div class="page-header-container">
  <div class="page-header-content">
    <md-page-header [title]="'NAV.SLAUGHTERHOUSES' | translate" icon="partner"></md-page-header>
    <mat-form-field class="page-header-right-column no-subscript">
      <mat-label>{{ 'SEARCH.PARTNERS.SLAUGHTERHOUSES' | translate }}</mat-label>
      <input matInput type="text" [formControl]="searchInput" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
</div>
<ag-grid-angular
  domLayout="autoHeight"
  [pagination]="true"
  [theme]="theme"
  [rowData]="displaySlaughterhouses()"
  [columnDefs]="columnDefs()"
  (rowClicked)="onRowClicked($event)"
></ag-grid-angular>
